import React from 'react';

export default function Hero() {
  return (
    <div className="hero slide">
      <div className="intro">
        <h1>Matt Goucher</h1>
        <h2>a Full-Stack Software Engineer</h2>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Hero.jsx